import React from 'react';

import GridContainer from './grid/grid_container.js';
import SidebarContainer from './sidebar/sidebar_container.js';

const App = () => (
  <div id="app">
    <GridContainer />
    <SidebarContainer />
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./frontend/components/app.jsx